// extracted by mini-css-extract-plugin
export default {"percent":"Percent_percent__hHGk1"};